import { useProvider } from "./context";
import { BsSearch } from "react-icons/bs";
export default function Search() {
  const { dispatch } = useProvider();
  return (
    <div className="search">
      <BsSearch />
      <input
        placeholder="Search"
        onChange={(e) => {
          dispatch({ type: "FILTER", payload: e.target.value });
        }}
      />
    </div>
  );
}
